import { Phone as o } from "./phone.js";
import { Laptop as r } from "./laptop.js";
import { Desktop as m } from "./desktop.js";
import { Monitoring as t } from "./monitoring.js";
import { Tablet as i } from "./tablet.js";
import { Watch as p } from "./watch.js";
import { Watch2 as f } from "./watch-2.js";
import { Fitbit as e } from "./fitbit.js";
import { Pos as a } from "./pos.js";
import { PosLarge as s } from "./pos-large.js";
import { PosTalk as n } from "./pos-talk.js";
import { Printer as P } from "./printer.js";
import { PosMedium as h } from "./pos-medium.js";
import { PosPlatform as l } from "./pos-platform.js";
import { Atm as T } from "./atm.js";
import { TerminalFleetManager as c } from "./terminal-fleet-manager.js";
import { PosInterfacesShopperExperience as g } from "./pos-interfaces-shopper-experience.js";
import { PosTestingTools as d } from "./pos-testing-tools.js";
import { Kiosk as W } from "./kiosk.js";
import { Webinar as M } from "./webinar.js";
import { PosGood as b } from "./pos-good.js";
import { PosWrong as k } from "./pos-wrong.js";
import { PosAndroid as y } from "./pos-android.js";
import { Display as A } from "./display.js";
import { Keypad as D } from "./keypad.js";
import { CashRegister as L } from "./cash-register.js";
import { PhoneAndWatch as x } from "./phone-and-watch.js";
import { TapToPay as F } from "./tap-to-pay.js";
import { LaptopMigration as G } from "./laptop-migration.js";
import { PosTerminalGrowth as K } from "./pos-terminal-growth.js";
const fo = {
  Phone: o,
  Laptop: r,
  Desktop: m,
  Monitoring: t,
  Tablet: i,
  Watch: p,
  Watch2: f,
  Fitbit: e,
  Pos: a,
  PosLarge: s,
  PosTalk: n,
  Printer: P,
  PosMedium: h,
  PosPlatform: l,
  Atm: T,
  TerminalFleetManager: c,
  PosInterfacesShopperExperience: g,
  PosTestingTools: d,
  Kiosk: W,
  Webinar: M,
  PosGood: b,
  PosWrong: k,
  PosAndroid: y,
  Display: A,
  Keypad: D,
  CashRegister: L,
  PhoneAndWatch: x,
  TapToPay: F,
  LaptopMigration: G,
  PosTerminalGrowth: K
};
export {
  fo as Devices40
};
